import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { setNotificationCount } from "../../state/actions";
import { useToastStore } from "../components/modules/Common/ToastProvider/store/useToastStore";
import { invalidateSession } from "../components/ui library/helpers/functions";
import DataContext from "../context/DataContext";
import { EventsDispatchContext } from "../context/EventsProvider";

const useLogout = () => {
  const {
    setAccessToken,
    setCaseManagerPk,
    setSelectedProvider,
    setSelectedClient,
    setUserType,
    setDashCompLimit,
    setErrorMessage,
    stopSse,
  } = useContext(DataContext);
  const globalEventDispatch = useContext(EventsDispatchContext);
  const clearAllToasts = useToastStore((state) => state.clearAllToasts);
  const navigate = useNavigate();

  const logout = useCallback(
    async ({ errorMessage = "", redirectTo = "/" } = {}) => {
      await invalidateSession({ redirectTo, skipRedirect: true });
      if (typeof stopSse === "function") {
        stopSse();
      }
      if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: "STOP_FETCHING" });
      }
      if (typeof clearAllToasts === "function") {
        clearAllToasts();
      }
      if (typeof globalEventDispatch === "function") {
        setNotificationCount(globalEventDispatch, 0);
      }
      setAccessToken("");
      setCaseManagerPk("");
      setSelectedProvider("");
      setSelectedClient("");
      setUserType("");
      setDashCompLimit(5);
      setErrorMessage(errorMessage);
      if (redirectTo) {
        navigate(redirectTo);
      }
    },
    [
      navigate,
      setAccessToken,
      setCaseManagerPk,
      setDashCompLimit,
      setErrorMessage,
      setSelectedClient,
      setSelectedProvider,
      setUserType,
      stopSse,
      clearAllToasts,
      globalEventDispatch,
    ]
  );

  return logout;
};

export default useLogout;
